<script setup>
import {reactive, onMounted, watch, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'AcctManagerBtnComponent';

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  isDisabled: false,
  loader: null,
  loading: false,
  message: '',
  valid: true,
  openMessage: false,
  sentConfirmation: 'Message created',
  sentMessage: false,
});

const form = ref(null);

const submit = () => {
  if (form.value.validate()) {
    data.openMessage = false;
    data.loader = 'loading'
    ApiWrapper.post('acct-manager-btn', 'create-message', {
          claimId: props.contextIdA,
          message: data.message,
        })
        .then((response) => {
          activeComponentStore.notifyComponents(['messages','updateTasks'],compName);
          data.message = ''
          data.sentMessage = true

          ToastUtil.successMsg('Account manager message successfully added!');
        })
        .catch((e) => {
          ToastUtil.error(e);
        });
  }
}

watch(data.loader,() => {
  setTimeout(() => (data.loader = null), 2000);
  setTimeout(() => (data.sentMessage = false), 6000);
});

onMounted(()=>{

});

</script>

<template>
  <v-container fluid>
      <v-btn
          x-large
          block
          class=" ma-0"
          color="primary"
          variant="elevated"
          v-if="data.openMessage === false"
          :loading="data.loading"
          :disabled="data.isDisabled === true"
          @click="data.openMessage = true; data.sentMessage = false"
      >
        Click If Account Manager Attention Needed
      </v-btn>
      <h3 class="ml-4" v-if="data.sentMessage === true && data.openMessage === false && data.loading === false">
        {{data.sentConfirmation}}
      </h3>
      <v-form
          v-if="data.openMessage === true"
          ref="form"
          v-model="data.valid"
          lazy-validation
      >
        <v-textarea
            v-model="data.message"
            prepend-inner-icon="mdi-pencil"
            clearable
            filled
            label="Message"
            auto-grow
            :rules="[v => !!v || 'Message is required']"
            required
        ></v-textarea>
        <v-btn
            class="error"
            v-if="data.openMessage === true"
            @click="data.openMessage = false"
        >
          Cancel
        </v-btn>
        <v-btn
            class="primary"
            v-if="data.openMessage === true"

            :disabled="!data.valid"
            @click="submit"
        >
          Submit
        </v-btn>
      </v-form>
  </v-container>
</template>

<style scoped>
  [v-cloak] {
    display: none;
  }
  .container {
    padding: 5px;
  }
</style>